import { createFileRoute, notFound } from "@tanstack/react-router";

import { partModelConstraintsQueries } from "@/api/resources/partModelConstraints/queries";
import { partModelsQueries } from "@/api/resources/partModels/queries";
import { partsQueries } from "@/api/resources/parts/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import PartPage from "@/components/Part/PartPage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/inventory/incoming/$part_id/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.inventory-incoming"),
        icon: <Icon.INVENTORY />,
        path: "/workspaces/$workspace_id/inventory/incoming",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id, part_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    const currentPart = await context.queryClient.ensureQueryData(partsQueries.byId(part_id));
    if (!currentPart) throw notFound();

    await Promise.all([
      context.queryClient.ensureQueryData(partModelsQueries.byId(currentPart.part_model_id)),
      context.queryClient.ensureQueryData(
        partModelConstraintsQueries.listByMatch({
          part_model_id: currentPart.part_model_id,
          deployment_id: currentPart.deployment_id,
        }),
      ),
    ]);

    const breadcrumbs: BreadcrumbsContext[] = [{ label: currentPart.part_model.name, icon: <Icon.PART /> }];
    context.breadcrumbs.splice(2, 1, ...breadcrumbs);
  },
  component: PartPage,
});
